// src/components/Dashboard.js
import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import DataTable from 'react-data-table-component';

const Projects = () => {
  const navigate = useNavigate();
  console.log(localStorage.getItem('authToken'));
  const [managers, setManagers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  const columns = [
    {
      name: 'Name',
      selector: row => row.firstName  + ' ' + row.lastName,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Project',
      selector: row => row.clientName,
      sortable: true,
    },
    {
      name: 'Action',
      cell: row => (
        <button
          onClick={() => navigate(`/projectdetails/${row.projectId}`)}
          style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          View Details
        </button>
      ),
    }
  ];
  
  useEffect(() => {
    const lower = searchText.toLowerCase();
    const filteredData = managers.filter(manager => {
      const name = `${manager.firstName+''+manager.lastName ?? ''}`.toLowerCase();
      const email = manager.email?.toLowerCase() || '';
      const clientName = manager.clientName?.toLowerCase() || '';

      return (
        name.includes(lower) ||
        email.includes(lower) ||
        clientName.includes(lower)
      );
    });

    setFiltered(filteredData);
  }, [searchText, managers]);
  useEffect(() => {
    axios.get('http://127.0.0.1:8000/api/allProjects')
      .then(response => {
        console.log("API Data:", response.data);
        setManagers(response.data);
        setFiltered(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching managers:", error);
        setLoading(false);
      });
  }, []);
  return (
    <div className="d-flex">
      <Sidebar />
      <div style={{ flex: 1 }}>
        <Topbar />
        <Container fluid className="mt-4">
          <Row className="g-4">
            <Col md={12}>
              <Card>
                <Card.Body>
                  <Card.Title>Project List</Card.Title>
                  <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                    <input
                      type="text"
                      placeholder="Search by name, email, or project"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc'
                      }}
                    />
                  </div>
                  <div style={{ padding: '20px' }}>
                    <DataTable
                      columns={columns}
                      data={filtered}
                      progressPending={loading}
                      pagination
                      striped
                      highlightOnHover
                      responsive
                    />
                  </div>             
                  </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Projects;
